import axios from 'axios';
import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getLicense = params => common.requestRaw(apiUrl + 'License', params, 'get');
export const addLicense = params => common.requestRaw(apiUrl + 'License', params, 'post');
//export const cancleAddLicense = params => common.requestRaw(apiUrl + 'License/InsertCancle', params, 'delete');
export const updateLicense = params => common.requestRaw(apiUrl + 'License', params, 'put');
export const deleteLicense = params => common.requestRaw(apiUrl + 'License', params, 'delete');



// WEBPACK FOOTER //
// ./src/script/libs/licenseLib.js